import { Label } from "@/components/ui/label";
import { ConnectionSelector } from "@/components/ConnectionSelector";
import { DynamicField } from "@/modules/agents/components/DynamicField";

interface AgentEmailConnectionFieldsProps {
  connectionId: string | null;
  onConnectionIdChange: (id: string | null) => void;
  fromAddress: string;
  onFromAddressChange: (value: string) => void;
}

/**
 * Agent email connection fields: the connection selector plus the sending
 * mailbox it unlocks. The inbound folder is configured on the trigger.
 * @param props - AgentEmailConnectionFieldsProps
 * @returns Fields for selecting an agent email connection and sending mailbox
 */
export function AgentEmailConnectionFields({
  connectionId,
  onConnectionIdChange,
  fromAddress,
  onFromAddressChange,
}: AgentEmailConnectionFieldsProps) {
  return (
    <>
      <div className="space-y-1.5">
        <Label>Agent Email Connection</Label>
        <ConnectionSelector
          appId="microsoft_outlook"
          providerId="pipedream"
          connectionId={connectionId}
          onSelect={onConnectionIdChange}
        />
      </div>
      {connectionId && (
        <div className="space-y-1.5">
          <Label>Send From Mailbox</Label>
          <DynamicField
            triggerId="receive_email_trigger_v2"
            fieldName="mailbox"
            connectionId={connectionId}
            value={fromAddress || undefined}
            placeholder="Select mailbox"
            onChange={(option) =>
              onFromAddressChange(String(option.input ?? ""))
            }
          />
        </div>
      )}
    </>
  );
}
